import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'
import {
	AUTH_RESET_PASSWORD_TYPE,
	AuthLoginModel,
	AuthTokenModel,
	ResetPasswordByTokenModel,
	Auth as AuthModel,
} from 'Pages/auth'
import { LocalStorage } from 'Modules'
import { PartnerPaymentModel } from 'Models'

const auth: AuthModel & AuthTokenModel = LocalStorage.getSessionId()
	? LocalStorage.getItem('substitution')
	: LocalStorage.getItem('auth')

interface AuthState extends AuthTokenModel, AuthModel {
	isFirstVisitAfterAuth: boolean
	isSuccessChangePassword: boolean
}
const AuthInitialState: AuthState = {
	...auth,
	isFirstVisitAfterAuth: false,
	isSuccessChangePassword: false,
}

export namespace AuthNS {
	export type SetLogin = PayloadAction<AuthTokenModel>
	export type SetUser = PayloadAction<AuthModel>
	export type SetChangePassword = PayloadAction<{ isSuccessChangePassword: boolean }>
	export type Login = PayloadAction<{
		data: AuthLoginModel
		callback?: Callback
		errorCallback?: Callback
	}>
	export type GetUser = PayloadAction<{
		id: number | string
		isAfterLogin?: boolean
		callback?: Callback
	}>
	export type UpdateUser = PayloadAction<Partial<AuthModel>>
	export type AfterLoginCalls = PayloadAction<AuthModel>
	export type SetInitial = PayloadAction
	export type Logout = PayloadAction
	export type UpdatePartnerPayment = PayloadAction<PartnerPaymentModel>
	export type LoginAs = PayloadAction<{ id: number | string }>
	export type ResetPassword = PayloadAction<AUTH_RESET_PASSWORD_TYPE>
	export type ResetPasswordByToken = PayloadAction<ResetPasswordByTokenModel>
	export type GetUserOnly = PayloadAction<{
		id: number | string
		callback?: Callback
	}>
	export type AfterLogin = PayloadAction<AuthTokenModel>

	export type RefreshPassword = PayloadAction<{
		old_password: string
		username: string
		password: string
		confirm_password: string
	}>
}

export const authSlice = createSlice({
	name: 'auth',
	initialState: AuthInitialState,
	reducers: {
		setLogin: (state, action: AuthNS.SetLogin) => {
			const newState = {
				...state,
				...action.payload,
			}
			return newState
		},
		setUser: (state, action: AuthNS.SetUser) => {
			return {
				...state,
				...action.payload,
			}
		},
		setChangePassword: (state, action: AuthNS.SetChangePassword) => {
			return {
				...state,
				...action.payload,
			}
		},
		login: (state, action: AuthNS.Login) => {},
		getUser: (state, action: AuthNS.GetUser) => {},
		updateUser: (state, action: AuthNS.UpdateUser) => {},
		afterLoginCalls: (state, action: AuthNS.AfterLoginCalls) => {},
		setInitial: (state, action: AuthNS.SetInitial) => {
			return null
		},
		logout: (state, action: AuthNS.Logout) => {},
		updatePartnerPayment: (state, action: AuthNS.UpdatePartnerPayment) => {},
		loginAs: (state, action: AuthNS.LoginAs) => {},
		resetPassword: (state, action: AuthNS.ResetPassword) => {},
		resetPasswordByToken: (state, action: AuthNS.ResetPasswordByToken) => {},
		getUserOnly: (state, action: AuthNS.GetUserOnly) => {},
		afterLogin: (state, action: AuthNS.AfterLogin) => {},
		refreshPassword: (state, action: AuthNS.RefreshPassword) => {},
	},
})
